import { render, staticRenderFns } from "./Saque.vue?vue&type=template&id=65fd6d9a&"
import script from "./Saque.vue?vue&type=script&lang=js&"
export * from "./Saque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports